import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type SendMoneyProps = IconComponentBaseProps;

export const SendMoney = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: SendMoneyProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7357_4612"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill={fill} />
      </mask>
      <g mask="url(#mask0_7357_4612)">
        <path
          d="M2.01929 12C2.01929 13.1718 2.3202 14.2382 2.92204 15.199C3.52404 16.16 4.32245 16.8808 5.31729 17.3615C5.49945 17.4628 5.63662 17.6064 5.72879 17.7923C5.82112 17.9783 5.83012 18.1673 5.75579 18.3595C5.68145 18.5622 5.54654 18.7042 5.35104 18.7855C5.15554 18.867 4.96679 18.8603 4.78479 18.7653C3.42062 18.1114 2.3687 17.1682 1.62904 15.9355C0.889204 14.7028 0.519287 13.391 0.519287 12C0.519287 10.6192 0.881454 9.315 1.60579 8.0875C2.33012 6.86 3.3692 5.91933 4.72304 5.2655C4.9052 5.1705 5.09662 5.16117 5.29729 5.2375C5.49779 5.31383 5.64037 5.45325 5.72504 5.65575C5.8097 5.83775 5.80845 6.02175 5.72129 6.20775C5.63412 6.39358 5.49945 6.53717 5.31729 6.6385C4.32245 7.11917 3.52404 7.84 2.92204 8.801C2.3202 9.76183 2.01929 10.8282 2.01929 12ZM14.0193 19.5C11.9373 19.5 10.1668 18.7705 8.70779 17.3115C7.24879 15.8525 6.51929 14.082 6.51929 12C6.51929 9.918 7.24879 8.1475 8.70779 6.6885C10.1668 5.2295 11.9373 4.5 14.0193 4.5C14.9013 4.5 15.7365 4.64042 16.525 4.92125C17.3135 5.20192 18.0302 5.59933 18.675 6.1135C18.8404 6.24167 18.9263 6.40542 18.9328 6.60475C18.9391 6.80408 18.8647 6.98133 18.7095 7.1365C18.5647 7.28133 18.3885 7.35733 18.1808 7.3645C17.9731 7.3715 17.7815 7.31092 17.6058 7.18275C17.0995 6.80325 16.5456 6.51125 15.9443 6.30675C15.343 6.10225 14.7013 6 14.0193 6C12.3526 6 10.936 6.58333 9.76929 7.75C8.60262 8.91667 8.01929 10.3333 8.01929 12C8.01929 13.6667 8.60262 15.0833 9.76929 16.25C10.936 17.4167 12.3526 18 14.0193 18C14.7013 18 15.343 17.8977 15.9443 17.6932C16.5456 17.4887 17.0995 17.1968 17.6058 16.8173C17.7815 16.6891 17.9731 16.6285 18.1808 16.6355C18.3885 16.6427 18.5647 16.7187 18.7095 16.8635C18.8647 17.0187 18.9391 17.1959 18.9328 17.3953C18.9263 17.5946 18.8404 17.7583 18.675 17.8865C18.0302 18.4007 17.3135 18.7981 16.525 19.0788C15.7365 19.3596 14.9013 19.5 14.0193 19.5ZM20.623 12.75H13.827C13.6142 12.75 13.436 12.6782 13.2923 12.5345C13.1488 12.391 13.077 12.2128 13.077 12C13.077 11.7872 13.1488 11.609 13.2923 11.4655C13.436 11.3218 13.6142 11.25 13.827 11.25H20.623L19.3 9.927C19.1615 9.7885 19.0907 9.61442 19.0875 9.40475C19.0844 9.19525 19.1552 9.018 19.3 8.873C19.4449 8.72817 19.6205 8.65575 19.827 8.65575C20.0334 8.65575 20.209 8.72817 20.3538 8.873L22.848 11.3672C23.0289 11.5481 23.1193 11.759 23.1193 12C23.1193 12.241 23.0289 12.4519 22.848 12.6328L20.3538 15.127C20.2155 15.2653 20.0415 15.3362 19.8318 15.3395C19.6221 15.3427 19.4449 15.2718 19.3 15.127C19.1552 14.982 19.0828 14.8063 19.0828 14.6C19.0828 14.3937 19.1552 14.218 19.3 14.073L20.623 12.75Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
